/**
 * Aplica `transform` ao valor de um input controlado enquanto a pessoa digita,
 * sem jogar o cursor para o fim. Grava o valor novo direto no elemento: o
 * React vê o state igual ao DOM e não reescreve o campo.
 *
 * A posição nova do cursor é o tamanho do trecho antes dele já transformado,
 * o que vale para transformações que olham cada caractere e o anterior
 * (capitalização, tirar espaço).
 */
export function transformInput(
  input: HTMLInputElement,
  transform: (value: string) => string,
): string {
  const value = input.value
  const next = transform(value)
  if (next === value) return value
  let caret: number | null = null
  try {
    caret = input.selectionStart
  } catch {
    // type=email/number não expõem seleção em alguns navegadores.
  }
  input.value = next
  if (caret !== null && document.activeElement === input) {
    const position = transform(value.slice(0, caret)).length
    input.setSelectionRange(position, position)
  }
  return next
}
